/**
 * External dependencies
 */
import { useQuery } from '@tanstack/react-query';

/**
 * Internal dependencies
 */

/**
 * Fetch instances
 * @returns {object}
 */
function useLocalVenueInstances({ postSlug, apiUrl }) {
	const { isPending, isError, data, error, refetch } = useQuery({
		queryKey: ['postSlug'],
		queryFn: async () => {
			const baseUrl = `${apiUrl}/wp-json/visitedu-block-theme/v1/events?venue=${postSlug}`;

			const url = new URL(baseUrl);

			const response = await fetch(url.href);

			return (await response.json()).data || [];
		},
	});

	return {
		data,
		error,
		isError,
		isPending,
		refetch,
	};
}

export { useLocalVenueInstances };
